type QueryValue =
  | string
  | number
  | null
  | undefined
  | boolean
  | (string | number)[];

export const getQueryString = (obj?: {
  [key: string]: QueryValue;
}): string => {
  if (!obj) return '';

  const parts: string[] = [];

  Object.keys(obj).forEach((key) => {
    const val = obj[key];
    if (val === null || val === undefined || val === '') return;
    if (Array.isArray(val)) {
      val.forEach((v) => {
        if (v !== '' && v !== null && v !== undefined) {
          parts.push(`${key}=${encodeURIComponent(String(v))}`);
        }
      });
    } else if (val !== false && val !== '') {
      parts.push(`${key}=${encodeURIComponent(String(val))}`);
    }
  });

  return parts.length ? '?' + parts.join('&') : '';
};

export const getFromQueryString = (str: string): { [key: string]: string } => {
  if (!str && !str?.startsWith('?')) return {};

  return Object.fromEntries(
    str
      ?.slice(1)
      ?.split('&')
      ?.map((item) => item?.split('=')) as [string, string][],
  );
};

export const getValuesByStringArray = (
  search: string,
  key: string,
): string[] => {
  const params = new URLSearchParams(search);

  const values = [];
  const regex = new RegExp(`^${key}\\[(\\d+)\\]$`);

  for (const [key, value] of params) {
    const match = key.match(regex);

    if (match) {
      values.push(value);
    }
  }

  return values;
};

export default {
  getQueryString,
  getValuesByStringArray,
  getFromQueryString,
};
